
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  Stack,
  Collapse,
  Divider,
  CircularProgress,
} from "@mui/material";
// import { useSelector } from "react-redux";
import { api } from "../../api/api";
import {
  helpcenter_form,
  // helpcenter_number,
  faqtitle,
  faqcontent,
  // LegalTitle,
  LegalContent
} from "../../api/urls";
import {
  NotepadText,
  CloudUpload,
  MessageCircleQuestion,
  ChevronRight,
  Scale,
  ChevronLeft,
  // Chevron

} from "lucide-react";
import Skeleton from '@mui/material/Skeleton';
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const objToFormdata = (data) => {
  const formData = new FormData();
  for (const key in data) {
    if (data[key] instanceof File || typeof data[key] === "string") {
      formData.append(key, data[key]);
    }
  }
  return formData;
};

const HelpCenter = () => {
  // const [users, setUsers] = useState([]);
  const location = useLocation();
  const [form, setForm] = useState({
    subject: "",
    fullname: "",
    order_no: "",
    product_image: "",
    product_description: "",
  });
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("write");
  const [faqTitles, setFaqTitles] = useState([]);
  const [faqAnswers, setFaqAnswers] = useState({});
  const [expandedFaqId, setExpandedFaqId] = useState(null);

  const [legalTitles, setLegalTitles] = useState([]);
  const [page, setpage] = useState(0);
  const [IDE, setIde] = useState(null);
  const [legalcontent, setlegalcontent] = useState([])
  const [expandedLegalId, setExpandedLegalId] = useState(null);
  // const [selectedLegalTitleId, setSelectedLegalTitleId] = useState(null);
  const [legalLoading, setLegalLoading] = useState(false);
  const [faqPage, setFaqPage] = useState(0);
  const [selectedFaqId, setSelectedFaqId] = useState(null);



 const queryParams = new URLSearchParams(location.search);
  const openSection = queryParams.get("open"); // "write", "faq", or "cancel"



  // const accessToken = useSelector((state) => state.auth.accessToken);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    setForm({ ...form, product_image: e.target.files[0] });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const formData = objToFormdata(form);
    try {
      await api.post(helpcenter_form, formData);
      // alert("Submitted successfully!");
      toast.success("Submitted successfully!");
      setForm({
        subject: "",
        fullname: "",
        order_no: "",
        product_image: "",
        product_description: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Submission failed.");
    } finally {
      setLoading(false);
    }
  };




  const handleFaqClick = async (id) => {
    setExpandedFaqId(null);

    setSelectedFaqId(id);
    setFaqPage(1);

    setExpandedFaqId(id);

    if (!faqAnswers[id]) {
      try {
        const url = `${faqcontent}?faqtitle=${id}`;
        const res = await api.get(url);
        if (res.data.length > 0) {
          setFaqAnswers((prev) => ({
            ...prev,
            [id]: res.data[0]?.content || res.data[0]?.answer || "No content available.",
          }));
        } else {
          setFaqAnswers((prev) => ({
            ...prev,
            [id]: "No content found for this topic.",
          }));
        }
      } catch (err) {
        setFaqAnswers((prev) => ({
          ...prev,
          [id]: "No content found for this topic.",
        }));
      }
    }
  };

  const change = (id) => {
    // setSelectedLegalTitleId(id);
    setpage(1);
    setIde(id);

  }
useEffect(() => {
  if (openSection) {
    setSelectedTab(openSection);
  }
}, [openSection]);
  useEffect(() => {
    const second = async () => {
      if (IDE) {
        setLegalLoading(true); // show loader
        try {
          const res = await api.get(`${LegalContent}?legaltitle=${IDE}`);
          setlegalcontent(res.data);
        } catch (error) {
          console.error("Error fetching legal content:", error);
        } finally {
          setLegalLoading(false); // hide loader
        }
      }
    };

    second();
  }, [IDE]);

  // useEffect(() => {
  //   const fetchHelpCenterNumbers = async () => {
  //     try {
  //       // const response = await api.get(helpcenter_number, {
  //       //   headers: {
  //       //     Authorization: `Bearer ${accessToken}`,
  //       //   },
  //       // });
  //       // setUsers(response.data);
  //     } catch (error) {
  //       console.error("Error fetching help center numbers:", error);
  //     }
  //   };
  //   fetchHelpCenterNumbers();
  // }, [accessToken]);

  useEffect(() => {
    const fetchFaqTitles = async () => {
      try {
        const res = await api.get(faqtitle);
        setFaqTitles(res.data);
      } catch (error) {
        console.error("Failed to load FAQ titles", error);
      }
    };
    fetchFaqTitles();
  }, []);

  useEffect(() => {
    const fetchLegalTitles = async () => {
      try {
        const res = await api.get("/legal-api/legaltitle/");
        setLegalTitles(res.data);
      } catch (error) {
        console.error("Failed to load legal titles", error);
      }
    };
    fetchLegalTitles();
  }, []);


  // const validPhoneNumbers = users.filter(
  //   (user) =>
  //     /^[\d+][\d\s\-()]+$/.test(user.mob_no) &&
  //     user.mob_no.length >= 10 &&
  //     !user.mob_no.includes("@@@") &&
  //     !user.mob_no.toLowerCase().includes("test") &&
  //     !user.mob_no.toLowerCase().includes("hi")
  // );

  return (
    <Box sx={{ width: "100%", maxWidth: 1200, mx: "auto", p: { xs: 2, sm: 3, md: 4 } }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "500", fontSize: "38px", mb: 4 }}>
        Help Center
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <Box
              onClick={() => {
                setSelectedTab("write")
                setpage(0)
                setFaqPage(0)
              }

              }


              sx={{
                p: 2,
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: selectedTab === "write" ? "#f5f5f5" : "transparent",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <NotepadText size={24} />
              <Box>
                <Typography fontWeight={600}>Write to us</Typography>
                <Typography fontSize={12} color="text.secondary">
                  Average response time: 24–48 hrs
                </Typography>
              </Box>
            </Box>

            <Box
              onClick={() => {
                setSelectedTab("faq")
                setpage(0)
              }}
              sx={{
                p: 2,
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: selectedTab === "faq" ? "#f5f5f5" : "transparent",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <MessageCircleQuestion size={24} />
              <Box>
                <Typography fontWeight={600}>FAQs</Typography>
                <Typography fontSize={12} color="text.secondary">
                  Frequently Asked Questions
                </Typography>
              </Box>
            </Box>

            <Box

              onClick={() => {
                setSelectedTab("legal")
                setFaqPage(0)
              }}
              sx={{
                p: 2,
                borderRadius: 2,
                cursor: "pointer",
                bgcolor: selectedTab === "legal" ? "#f5f5f5" : "transparent",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}

            >
              <Scale />

              <Box>
                <Typography fontWeight={600} >Legal Services</Typography>
                <Typography fontSize={12} color="text.secondary">
                  Legal terms, policies, and more
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Grid>

        <Grid item xs={12} md={6}>
          {selectedTab === "write" ? (
            <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: "1px solid #cccccc" }}>
              <Grid container spacing={2}>
                {[{ label: "Subject", name: "subject" }, { label: "Full Name", name: "fullname" }, { label: "Order Number", name: "order_no" }].map((field) => (
                  <Grid item xs={12} key={field.name}>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500, mb: 1 }}>{field.label}</Typography>
                    <TextField
                      fullWidth
                      size="small"
                      name={field.name}
                      value={form[field.name]}
                      onChange={handleChange}
                      placeholder={field.label}
                    />
                  </Grid>
                ))}

                <Grid item xs={12}>
                  <Typography fontSize={14} fontWeight={500} mb={1}>
                    Upload Image
                  </Typography>
                  <Box
                    sx={{
                      border: "2px dashed #ccc",
                      p: 3,
                      borderRadius: 2,
                      textAlign: "center",
                      position: "relative",
                      bgcolor: "#fafafa",
                      "&:hover": {
                        borderColor: "primary.main",
                        bgcolor: "#e3f2fd",
                      },
                    }}
                  >
                    <CloudUpload />
                    <Typography variant="body2" mt={1}>
                      Drag & Drop or <Typography component="span" color="primary" fontWeight={600}>Browse</Typography>
                    </Typography>
                    <input
                      type="file"
                      name="product_image"
                      onChange={handleImageChange}
                      style={{ position: "absolute", inset: 0, opacity: 0, cursor: "pointer" }}
                    />
                  </Box>
                  {form.product_image && (
                    <Typography variant="caption" mt={1} display="block">
                      Selected: {form.product_image.name}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Typography fontSize={14} fontWeight={500} mb={1}>
                    Description
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    size="small"
                    name="product_description"
                    value={form.product_description}
                    onChange={handleChange}
                    placeholder="Type your message here..."
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{
                      textTransform: "none",
                      py: 1.3,
                      fontWeight: 600,
                      mt: 6,
                      fontSize: "1rem",
                      borderRadius: 2,
                      bgcolor: "black",
                      "&:hover": { bgcolor: "#333" },
                      "&:disabled": { bgcolor: "#999", color: "#eee" },
                    }}
                  >
                    {loading ? (
                      <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                        <CircularProgress size={20} color="inherit" />
                        Submitting...
                      </Box>
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          ) : selectedTab === "faq" ? (
            <>
              {faqPage === 1 && (
                <Box sx={{ mb: 2 }}>
                  <Button
                    onClick={() => {
                      setFaqPage(0);
                      setExpandedFaqId(null);
                    }}
                    startIcon={<ChevronLeft sx={{ transform: "rotate(180deg)" }} />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "#333",
                      mb: 1,
                    }}
                  >
                    Back
                  </Button>
                </Box>
              )}

              <Paper
                elevation={0}
                sx={{ p: 3, border: "1px solid #D3D3D3", borderRadius: 3, minHeight: "300px" }}
              >
                {faqPage === 0 &&
                  faqTitles.map((faq) => (
                    <Box key={faq.id}>
                      <Typography
                        onClick={() => {
                          setExpandedFaqId(null);
                          handleFaqClick(faq.id);
                          setFaqPage(1);
                        }}


                        sx={{
                          fontWeight: "500",
                          cursor: "pointer",
                          py: 1.5,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          px: 1,
                          borderRadius: 1,
                          // bgcolor: selectedFaqId === faq.id ? "creditDetailsmato" : "transparent",
                        }}
                      >
                        {faq.printable_name}
                        <ChevronRight size={20} color="#ccc" />
                      </Typography>
                      <Divider />
                    </Box>
                  ))}

                {faqPage === 1 &&
                  faqTitles
                    .filter((faq) => faq.id === selectedFaqId)
                    .map((faq) => (
                      <Box key={faq.id}>
                        <Box
                          // onClick={() => setExpandedFaqId(faq.id)}
                          onClick={() =>
                            setExpandedFaqId((prevId) => (prevId === faq.id ? null : faq.id))
                          }

                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                            py: 1.5,
                          }}
                        >
                          <Typography fontSize={14} fontWeight={500}>
                            {faq.printable_name}
                          </Typography>
                          <ChevronRight
                            size={20}
                            color="#ccc"
                            style={{
                              transition: "transform 0.3s ease",
                              transform: expandedFaqId === faq.id ? "rotate(90deg)" : "rotate(0deg)",
                            }}
                          />
                        </Box>
                        <Collapse in={expandedFaqId === faq.id} timeout="auto" unmountOnExit>
                          <Box sx={{ pl: 2, pb: 1 }}>
                            <Typography fontSize={14}>
                              {faqAnswers[faq.id] || "Loading..."}
                            </Typography>
                          </Box>
                        </Collapse>
                      </Box>
                    ))}
              </Paper>
            </>
          ) : (



            <>
              {selectedTab === "legal" && (
                <Box>
                  {/* Back button only when viewing content (page 1) */}
                  {page === 1 && (
                    <Box sx={{ mb: 2 }}>
                      <Button
                        onClick={() => {
                          setpage(0); // Go back to legal title list
                          setExpandedLegalId(null);
                        }}
                        startIcon={<ChevronLeft sx={{ transform: "rotate(180deg)" }} />}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#333",
                          mb: 1,
                        }}
                      >
                        Back
                      </Button>

                    </Box>
                  )}

                  <Paper elevation={0} sx={{ p: 3, border: "1px solid #D3D3D3", borderRadius: 3, minHeight: "300px" }}>
                    {page === 0 &&
                      legalTitles.map((elem) => (
                        <Box key={elem.id}>
                          <Typography
                            onClick={() => change(elem.id)}
                            sx={{
                              mb: 1,
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              py: 1,
                              // bgcolor: selectedLegalTitleId === elem.id ? "tamato" : "transparent",

                              px: 1,
                              borderRadius: 1,
                            }}
                          >
                            {elem.printable_name}
                            <ChevronRight size={20} color="#ccc" />
                          </Typography>
                          <Divider sx={{ my: 0 }} />
                        </Box>
                      ))}



                    {page === 1 ? (
                      legalLoading ? (
                        // Show skeleton while loading
                        <>
                          {[...Array(3)].map((_, index) => (
                            <Box key={index} sx={{ py: 1.5 }}>
                              {/* <Skeleton width="60%" height={20} /> */}
                              <Skeleton width="90%" height={50} sx={{ mt: 1 }} />
                            </Box>
                          ))}
                        </>
                      ) : legalcontent.length === 0 ? (
                        // Show fallback if no content loaded
                        <Typography color="text.secondary">No content available.</Typography>
                      ) : (
                        // Show the actual content
                        legalcontent.map((e) => (
                          <Box key={e.id}>
                            <Box
                              onClick={() =>
                                setExpandedLegalId(expandedLegalId === e.id ? null : e.id)
                              }
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                                py: 1.5,
                              }}
                            >
                              <Typography fontSize={14} fontWeight={500}>
                                {e.title}
                              </Typography>
                              <ChevronRight
                                size={20}
                                color="#ccc"
                                style={{
                                  transition: "transform 0.3s ease",
                                  transform:
                                    expandedLegalId === e.id ? "rotate(90deg)" : "rotate(0deg)",
                                }}
                              />
                            </Box>

                            <Collapse in={expandedLegalId === e.id} timeout="auto" unmountOnExit>
                              <Box sx={{ pl: 2, pb: 1 }}>
                                <Typography fontSize={14} color="text.secondary">
                                  {e.content}
                                </Typography>
                              </Box>
                            </Collapse>
                          </Box>
                        ))
                      )
                    ) : null}

                  </Paper>
                </Box>
              )}

            </>


          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default HelpCenter;


